/* Affy — global UI interactions (no cart; see cart.js). */
(function () {
  'use strict';
  var doc = document;
  var $ = function (s, c) { return (c || doc).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); };

  /* ---- enable scroll-snap only after load ----
     scroll-snap-type present on a scroller at first paint suppresses Largest Contentful Paint in
     Chromium (Lighthouse reports NO_LCP and the whole Performance score errors out). We defer it
     until after load — LCP is already recorded by then — so carousels still snap without breaking the metric. */
  (function () {
    var on = function () { doc.documentElement.classList.add('snap-on'); };
    if (doc.readyState === 'complete') { setTimeout(on, 700); }
    else { window.addEventListener('load', function () { setTimeout(on, 700); }); }
  })();

  /* ---- sticky header ---- */
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-stuck', window.scrollY > 20); };
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---- mobile drawer ---- */
  var drawer = $('[data-drawer]'), drawerScrim = $('[data-drawer-scrim]');
  function openDrawer() { if (!drawer) return; drawer.classList.add('open'); drawer.setAttribute('aria-hidden', 'false'); if (drawerScrim) drawerScrim.classList.add('on'); doc.body.classList.add('no-scroll'); $$('[data-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); }); var df = $('[data-drawer-close]', drawer) || drawer; if (df) setTimeout(function () { try { df.focus(); } catch (e) {} }, 60); }
  function dropFocus(el, fallback) { if (el && el.contains(doc.activeElement)) { var f = fallback || null; if (f) { try { f.focus(); } catch (e) { doc.activeElement.blur(); } } else if (doc.activeElement.blur) doc.activeElement.blur(); } } // move focus OUT before aria-hidden (browsers block hiding a focused subtree)
  function closeDrawer() { if (!drawer) return; dropFocus(drawer, $('[data-drawer-open]')); drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true'); if (drawerScrim) drawerScrim.classList.remove('on'); doc.body.classList.remove('no-scroll'); $$('[data-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); }); }
  $$('[data-drawer-open]').forEach(function (b) { b.addEventListener('click', openDrawer); });
  $$('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
  if (drawerScrim) drawerScrim.addEventListener('click', closeDrawer);

  /* ---- search modal ---- */
  var searchModal = $('[data-search-modal]');
  function openSearch() { if (!searchModal) return; searchModal.classList.add('open'); searchModal.setAttribute('aria-hidden', 'false'); var i = $('input[type="search"]', searchModal); if (i) setTimeout(function () { i.focus(); }, 60); }
  function closeSearch() { if (!searchModal) return; dropFocus(searchModal, $('[data-search-open]')); searchModal.classList.remove('open'); searchModal.setAttribute('aria-hidden', 'true'); }
  $$('[data-search-open]').forEach(function (b) { b.addEventListener('click', openSearch); });
  $$('[data-search-close]').forEach(function (b) { b.addEventListener('click', closeSearch); });
  doc.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeSearch(); closeDrawer(); } });

  /* ---- reveal on scroll (.rise) ---- */
  /* Arm hiding ONLY now that JS is running — if this file fails to load, content stays visible. */
  doc.documentElement.classList.add('rise-ready');
  var rises = $$('.rise');
  if ('IntersectionObserver' in window && rises.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    rises.forEach(function (el) { io.observe(el); });
  } else { rises.forEach(function (el) { el.classList.add('in'); }); }
  /* safety net: never leave content hidden */
  window.addEventListener('load', function () { setTimeout(function () { $$('.rise:not(.in)').forEach(function (el) { el.classList.add('in'); }); }, 1200); });

  /* ---- announcement rotator ---- */
  $$('[data-announce-rot]').forEach(function (rot) {
    var msgs = $$('.announce__msg', rot); if (msgs.length < 2) return; var i = 0;
    setInterval(function () { msgs[i].classList.remove('on'); i = (i + 1) % msgs.length; msgs[i].classList.add('on'); }, 4200);
  });

  /* ---- product tabs (hidden panels lazy-load their products on first open) ---- */
  function loadPanel(panel) {
    if (!panel || panel.__loaded) return;
    var src = panel.getAttribute('data-lazy-src');
    if (!src) return;
    panel.__loaded = true; // guard against double-fetch
    var count = parseInt(panel.getAttribute('data-lazy-count'), 10) || 12;
    var track = $('.carousel__track', panel);
    fetch(src, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(); })
      .then(function (html) {
        var tmp = doc.createElement('div'); tmp.innerHTML = html;
        var cards = $$('.pcard', tmp).slice(0, count);
        if (cards.length && track) {
          track.innerHTML = '';
          cards.forEach(function (c) { track.appendChild(c); });
          window.dispatchEvent(new Event('resize')); // re-measure the carousel arrows
        }
      })
      .catch(function () { panel.__loaded = false; }); // allow a retry next time the tab is opened
  }
  $$('[data-tabs]').forEach(function (tabs) {
    var scope = tabs.closest('section') || doc;
    $$('.tab', tabs).forEach(function (tab) {
      tab.addEventListener('click', function () {
        $$('.tab', tabs).forEach(function (t) { t.classList.remove('on'); });
        tab.classList.add('on');
        var id = tab.getAttribute('data-tab');
        $$('[data-panel]', scope).forEach(function (p) {
          p.hidden = (p.id !== id);
          if (!p.hidden) { p.classList.add('in'); $$('.rise', p).forEach(function (e) { e.classList.add('in'); }); loadPanel(p); }
        });
        var cta = scope.querySelector('[data-tab-cta]');
        if (cta) {
          var u = tab.getAttribute('data-col-url'), l = tab.getAttribute('data-col-label');
          if (u) cta.setAttribute('href', u);
          if (l) cta.textContent = l;
        }
        window.dispatchEvent(new Event('resize'));
      });
    });
  });

  /* ---- collection directory: scrollable rows with arrows ---- */
  $$('[data-colnav-scroller]').forEach(function (sc) {
    var row = sc.querySelector('[data-colnav-row]');
    if (!row) return;
    var prev = sc.querySelector('[data-colnav-prev]'), next = sc.querySelector('[data-colnav-next]');
    var sw = 0, cw = 0; // cached extents — scrollWidth/clientWidth change on resize/font-swap, never on scroll
    function measure() { sw = row.scrollWidth; cw = row.clientWidth; update(); }
    function update() { // rAF-coalesced; scroll hot-path reads ONLY scrollLeft (no forced layout mid-scroll)
      if (update._raf) return;
      update._raf = requestAnimationFrame(function () {
        update._raf = 0;
        var sl = row.scrollLeft;
        sc.classList.toggle('can-scroll', sw - cw > 2);
        if (prev) prev.disabled = sl <= 1;
        if (next) next.disabled = sl + cw >= sw - 1;
      });
    }
    function step(dir) { row.scrollBy({ left: dir * Math.max(160, cw * 0.7), behavior: 'smooth' }); }
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); step(-1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); step(1); });
    row.addEventListener('scroll', update, { passive: true });
    // re-measure extents on any size change (resize / font swap / lazy content); ResizeObserver fires post-layout → no forced reflow
    if (window.ResizeObserver) new ResizeObserver(measure).observe(row);
    else { window.addEventListener('resize', measure); if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(measure); setTimeout(measure, 60); measure(); }
  });

  /* ---- homepage tab strips (Featured products + Shop by category): single-row scroll with arrows ---- */
  $$('[data-tabscroll]').forEach(function (sc) {
    var row = sc.querySelector('[data-tabs]');
    if (!row) return;
    var prev = sc.querySelector('[data-tabscroll-prev]'), next = sc.querySelector('[data-tabscroll-next]');
    var sw = 0, cw = 0; // cached extents (see colnav scroller note)
    function measure() { sw = row.scrollWidth; cw = row.clientWidth; update(); }
    function update() { // rAF-coalesced; scroll hot-path reads ONLY scrollLeft
      if (update._raf) return;
      update._raf = requestAnimationFrame(function () {
        update._raf = 0;
        var sl = row.scrollLeft;
        sc.classList.toggle('can-scroll', sw - cw > 2);
        if (prev) prev.disabled = sl <= 1;
        if (next) next.disabled = sl + cw >= sw - 1;
      });
    }
    function step(dir) { row.scrollBy({ left: dir * Math.max(200, cw * 0.7), behavior: 'smooth' }); }
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); step(-1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); step(1); });
    row.addEventListener('scroll', update, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(measure).observe(row);
    else { window.addEventListener('resize', measure); if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(measure); setTimeout(measure, 60); measure(); }
    // clicking a tab scrolls it into view within the strip
    $$('.tab', row).forEach(function (t) {
      t.addEventListener('click', function () {
        row.scrollTo({ left: Math.max(0, t.offsetLeft - (cw - t.offsetWidth) / 2), behavior: 'smooth' });
      });
    });
  });

  /* ---- collection directory: category sub-menus open in the panel BELOW the scroll row (so the row can
     scroll at any width without clipping the menu). Hover on desktop (mouse), tap on mobile/touch. ---- */
  function colnavCloseAll() {
    $$('.colnav__cat.is-open').forEach(function (c) { c.classList.remove('is-open'); var t = c.querySelector('.colnav__cattrigger'); if (t) t.setAttribute('aria-expanded', 'false'); });
    $$('[data-colnav-mpanel]').forEach(function (m) { m.hidden = true; m.innerHTML = ''; });
  }
  function colnavOpen(cat) {
    colnavCloseAll();
    cat.classList.add('is-open');
    var trig = cat.querySelector('.colnav__cattrigger'); if (trig) trig.setAttribute('aria-expanded', 'true');
    var nav = cat.closest('.colnav'), mpanel = nav && nav.querySelector('[data-colnav-mpanel]'), dd = cat.querySelector('.colnav__dropdown');
    if (mpanel && dd) { mpanel.innerHTML = dd.innerHTML; mpanel.hidden = false; }
  }
  var colnavHover = window.matchMedia && window.matchMedia('(min-width:721px) and (hover:hover)').matches;
  doc.addEventListener('click', function (e) {
    var trig = e.target.closest('.colnav__cattrigger');
    if (!trig) { if (!e.target.closest('.colnav')) colnavCloseAll(); return; }
    e.preventDefault();
    if (colnavHover) return; // desktop uses hover
    var cat = trig.closest('.colnav__cat');
    if (cat.classList.contains('is-open')) colnavCloseAll(); else colnavOpen(cat);
  });
  if (colnavHover) {
    $$('.colnav__cat').forEach(function (cat) { cat.addEventListener('mouseenter', function () { colnavOpen(cat); }); });
    $$('.colnav').forEach(function (nav) { nav.addEventListener('mouseleave', colnavCloseAll); });
  }

  /* ---- testimonials rotator ---- */
  $$('.testi').forEach(function (testi) {
    var slides = $$('[data-testi]', testi), who = $('[data-testi-who]', testi), dotsWrap = $('[data-testi-dots]', testi);
    if (!slides.length) return; var idx = 0;
    var authors = slides.map(function (s) { return s.getAttribute('data-author') || (who ? who.textContent : ''); });
    if (dotsWrap) { slides.forEach(function (_, i) { var d = doc.createElement('button'); d.className = 'testi__dot' + (i === 0 ? ' on' : ''); d.setAttribute('aria-label', 'Testimonial ' + (i + 1)); d.addEventListener('click', function () { show(i); }); dotsWrap.appendChild(d); }); }
    function show(n) {
      slides[idx].hidden = true; slides[idx].classList.remove('on');
      idx = (n + slides.length) % slides.length;
      slides[idx].hidden = false; slides[idx].classList.add('on');
      if (dotsWrap) $$('.testi__dot', dotsWrap).forEach(function (d, i) { d.classList.toggle('on', i === idx); });
    }
    setInterval(function () { show(idx + 1); }, 5200);
  });

  /* ---- reels: play on hover / in view, slider nav ---- */
  $$('[data-reels]').forEach(function (wrap) {
    var track = $('[data-reels-track]', wrap);
    var prev = $('[data-reels-prev]', wrap), next = $('[data-reels-next]', wrap);
    function step(dir) { if (!track) return; var card = track.querySelector('.reel'); var w = card ? card.offsetWidth + 18 : 320; track.scrollBy({ left: dir * w * 2, behavior: 'smooth' }); }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    $$('[data-reel]', wrap).forEach(function (v) {
      v.addEventListener('mouseenter', function () { v.play().catch(function () {}); });
      v.addEventListener('mouseleave', function () { v.pause(); });
    });
    if ('IntersectionObserver' in window) {
      var vio = new IntersectionObserver(function (ents) { ents.forEach(function (e) { var v = e.target; if (e.isIntersecting && e.intersectionRatio > 0.6) { v.play().catch(function () {}); } else { v.pause(); } }); }, { threshold: [0, 0.6] });
      $$('[data-reel]', wrap).forEach(function (v) { vio.observe(v); });
    }
  });

  /* ---- cut-off countdown ---- */
  $$('[data-cutoff-hour]').forEach(function (el) {
    var hour = parseInt(el.getAttribute('data-cutoff-hour'), 10) || 16;
    var out = $('[data-cutoff-out]', el) || el;
    function tick() {
      var now = new Date(); var cut = new Date(); cut.setHours(hour, 0, 0, 0);
      if (now > cut) { out.innerHTML = 'Order now for delivery <b>tomorrow</b>.'; return; }
      var ms = cut - now, h = Math.floor(ms / 3.6e6), m = Math.floor((ms % 3.6e6) / 6e4);
      out.innerHTML = 'Order within <b>' + h + 'h ' + m + 'm</b> for delivery today.';
    }
    tick(); setInterval(tick, 60000);
  });

  /* ---- Build-a-bouquet configurator ---- */
  $$('[data-byo]').forEach(function (byo) {
    var form = $('[data-byo-form]', byo);
    if (!form) return;
    var base = parseFloat(form.getAttribute('data-base')) || 0;
    function recompute() {
      var total = base;
      $$('[data-byo-group]', form).forEach(function (group) {
        var active = $('button.on', group);
        var prop = $('[data-byo-prop]', group);
        if (active) { total += parseFloat(active.getAttribute('data-price')) || 0; if (prop) prop.value = active.getAttribute('data-name') || ''; }
      });
      $$('[data-byo-total]', byo).forEach(function (t) { t.textContent = Math.round(total).toLocaleString('en-US'); });
      var bloomBtn = $('[data-byo-group="bloom"] button.on', form) || $('button[data-hue].on', form);
      var bloom = $('[data-byo-bloom]', byo);
      if (bloom && bloomBtn && bloomBtn.getAttribute('data-hue')) bloom.style.filter = 'hue-rotate(' + (parseInt(bloomBtn.getAttribute('data-hue'), 10) - 345) + 'deg)';
    }
    $$('[data-byo-group]', form).forEach(function (group) {
      $$('button', group).forEach(function (btn) {
        btn.addEventListener('click', function (e) { e.preventDefault(); $$('button', group).forEach(function (b) { b.classList.remove('on'); }); btn.classList.add('on'); recompute(); });
      });
    });
    // initialise hidden props on load
    recompute();
  });

  /* ---- quantity steppers (non-cart pages; cart.js handles cart qty) ---- */
  $$('[data-qty]').forEach(function (q) {
    if (q.closest('[data-cart-item]')) return; // cart.js owns these
    var input = $('[data-qty-input]', q);
    if (!input) return;
    $('[data-qty-minus]', q) && $('[data-qty-minus]', q).addEventListener('click', function () { input.value = Math.max(parseInt(input.min || 1, 10), (parseInt(input.value, 10) || 1) - 1); input.dispatchEvent(new Event('change', { bubbles: true })); });
    $('[data-qty-plus]', q) && $('[data-qty-plus]', q).addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 0) + 1; input.dispatchEvent(new Event('change', { bubbles: true })); });
  });

  /* ---- accordion (details) polish is CSS; nothing needed ---- */
})();

/* ---- emirate / delivery-city selector (ported) ---- */
(function () {
  'use strict';
  var EMIRATES = ['Dubai', 'Abu Dhabi', 'Sharjah', 'Ajman', 'Ras Al Khaimah', 'Fujairah', 'Umm Al Quwain'];
  var KEY = 'bloomistry-city', city;
  try { city = localStorage.getItem(KEY); } catch (e) {}
  if (EMIRATES.indexOf(city) === -1) city = null;
  function apply() {
    if (city) document.querySelectorAll('[data-city-label]').forEach(function (l) { l.textContent = city; });
    document.querySelectorAll('.loc-menu__item').forEach(function (i) { i.classList.toggle('on', i.getAttribute('data-emirate') === city); });
  }
  function setCity(c) { city = c; try { localStorage.setItem(KEY, c); } catch (e) {} apply(); }
  function closeAll(except) { document.querySelectorAll('.loc-menu').forEach(function (m) { if (m !== except) m.hidden = true; }); document.querySelectorAll('[data-loc]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); }); }
  function init() {
    document.querySelectorAll('[data-loc-wrap]').forEach(function (wrap) {
      if (wrap.__cityInit) return; wrap.__cityInit = true;
      var btn = wrap.querySelector('[data-loc]'); if (!btn) return;
      if (!city) { var lbl = wrap.querySelector('[data-city-label]'); if (lbl && lbl.textContent.trim()) city = lbl.textContent.trim(); }
      var menu = document.createElement('div');
      menu.className = 'loc-menu'; menu.setAttribute('role', 'listbox'); menu.hidden = true;
      menu.innerHTML = '<div class="loc-menu__head">Deliver to</div>' +
        EMIRATES.map(function (e) { return '<button class="loc-menu__item" type="button" role="option" data-emirate="' + e + '">' + e + '</button>'; }).join('');
      wrap.appendChild(menu);
      btn.addEventListener('click', function (ev) { ev.preventDefault(); ev.stopPropagation(); var willOpen = menu.hidden; closeAll(menu); menu.hidden = !willOpen; btn.setAttribute('aria-expanded', String(willOpen)); });
      menu.addEventListener('click', function (ev) { var it = ev.target.closest('[data-emirate]'); if (!it) return; setCity(it.getAttribute('data-emirate')); menu.hidden = true; btn.setAttribute('aria-expanded', 'false'); });
    });
    document.addEventListener('click', function () { closeAll(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
    apply();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* ---- auto sliders / carousels (ported) ---- */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function initCarousels(scope) {
    $$('[data-carousel]', scope || document).forEach(function (car) {
      if (car.__car) return; car.__car = true;
      var track = $('.carousel__track', car);
      if (!track) return;
      $$('.rise', track).forEach(function (e) { e.classList.add('in'); });
      var prev = $('[data-carousel-prev]', car), next = $('[data-carousel-next]', car);
      var sw = 0, cw = 0; // cached extents (see colnav scroller note)
      function measure() { sw = track.scrollWidth; cw = track.clientWidth; update(); }
      function step() { var c = track.firstElementChild; return c ? c.getBoundingClientRect().width + 22 : 280; }
      function update() { // rAF-coalesced; scroll hot-path reads ONLY scrollLeft
        if (update._raf) return;
        update._raf = requestAnimationFrame(function () {
          update._raf = 0;
          var sl = track.scrollLeft;
          car.classList.toggle('is-static', sw <= cw + 8);
          if (prev) prev.disabled = sl < 6;
          if (next) next.disabled = sl + cw >= sw - 6;
        });
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      // re-measure extents on any size change (resize / font swap / lazy cards); ResizeObserver fires post-layout → no forced reflow
      if (window.ResizeObserver) new ResizeObserver(measure).observe(track);
      else { window.addEventListener('resize', measure); setTimeout(measure, 120); measure(); }
      if (car.hasAttribute('data-autoplay') && !reduce && window.innerWidth > 749) {
        var paused = false;
        car.addEventListener('pointerenter', function () { paused = true; });
        car.addEventListener('pointerleave', function () { paused = false; });
        car.addEventListener('touchstart', function () { paused = true; }, { passive: true });
        setInterval(function () {
          if (paused || !car.offsetParent || sw <= cw + 8) return;
          if (track.scrollLeft + cw >= sw - 6) track.scrollTo({ left: 0, behavior: 'smooth' });
          else track.scrollBy({ left: step(), behavior: 'smooth' });
        }, 3800);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initCarousels(); });
  else initCarousels();
  window.__initCarousels = initCarousels;
})();

/* ---- predictive search (live results via Section Rendering API) ---- */
(function () {
  'use strict';
  var modal = document.querySelector('[data-search-modal]');
  if (!modal) return;
  var input = modal.querySelector('input[type="search"]');
  var results = modal.querySelector('[data-predictive-results]');
  var hint = modal.querySelector('[data-search-hint]');
  if (!input || !results) return;
  var T = window.theme || {}, base = (T.routes && T.routes.predictive_search_url) || '/search/suggest';
  var timer, lastQ = '', controller;
  function show(html) { results.innerHTML = html; results.hidden = false; if (hint) hint.hidden = true; }
  function clear() { results.hidden = true; results.innerHTML = ''; lastQ = ''; if (hint) hint.hidden = false; }
  function run(q) {
    var url = base + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&section_id=predictive-search';
    if (controller) { try { controller.abort(); } catch (e) {} }
    controller = ('AbortController' in window) ? new AbortController() : null;
    results.classList.add('is-loading');
    fetch(url, controller ? { signal: controller.signal } : {})
      .then(function (r) { return r.text(); })
      .then(function (html) {
        results.classList.remove('is-loading');
        if (input.value.trim() !== q) return;
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        show(parsed.body.innerHTML.trim());
      })
      .catch(function (e) { if (e && e.name === 'AbortError') return; results.classList.remove('is-loading'); });
  }
  input.addEventListener('input', function () {
    var q = input.value.trim();
    clearTimeout(timer);
    if (q.length < 2) { clear(); return; }
    if (q === lastQ) return;
    lastQ = q;
    timer = setTimeout(function () { run(q); }, 200);
  });
  // reset when modal reopens empty
  modal.addEventListener('transitionend', function () { if (!modal.classList.contains('open')) clear(); });
})();

/* ---- Double-submit guard: on a real (validated) form submission, disable the submit button and show a
   spinner so a slow response can't be double-submitted. AJAX /cart/add forms manage their own loading in
   cart.js (skipped here); JS-prevented / invalid submits are skipped via e.defaultPrevented and native
   validation (which suppresses the submit event). Buttons re-enable on navigation (pageshow) and via a
   safety timeout, so they can never stick disabled. ---- */
(function () {
  var doc = document;
  var $ = function (s, c) { return (c || doc).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); };
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM' || e.defaultPrevented) return;
    if (/\/cart\/add/.test(form.getAttribute('action') || '')) return; // cart.js owns add-to-cart loading
    var btns = form.querySelectorAll('button[type="submit"], button:not([type]), input[type="submit"]');
    Array.prototype.forEach.call(btns, function (b) {
      if (b.disabled || b.hasAttribute('data-no-loading')) return;
      b.classList.add('is-loading');
      b.setAttribute('aria-busy', 'true');
      setTimeout(function () { b.disabled = true; }, 0); // after the submit starts, so name/value still posts
      var clear = function () { b.disabled = false; b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); };
      window.addEventListener('pageshow', clear, { once: true });
      setTimeout(clear, 15000); // safety net — never stay stuck
    });
  });

  /* ---- collection filter drawer (mobile): slide-out filters with BATCH apply.
     On mobile, tapping a facet no longer reloads per tap — selections accumulate and apply together
     when the drawer closes (Show results / X / overlay / Esc). Desktop keeps instant inline filtering. ---- */
  (function () {
    var toggle = $('[data-filter-open]'); if (!toggle) return;
    var drawer = $('#ColFilters'), overlay = $('.col-filter-overlay'), form = $('[data-facet-form]');
    var lastFocus = null, dirty = false;
    function onKey(e) { if (e.key === 'Escape') finish(); }
    function open() {
      if (overlay) overlay.hidden = false;
      requestAnimationFrame(function () { if (drawer) drawer.classList.add('is-open'); if (overlay) overlay.classList.add('is-open'); });
      doc.documentElement.style.overflow = 'hidden';
      toggle.setAttribute('aria-expanded', 'true');
      lastFocus = doc.activeElement;
      var x = drawer && $('.col-filters__x', drawer); if (x) x.focus();
      doc.addEventListener('keydown', onKey);
    }
    function visualClose() {
      if (drawer) drawer.classList.remove('is-open');
      if (overlay) { overlay.classList.remove('is-open'); setTimeout(function () { overlay.hidden = true; }, 260); }
      doc.documentElement.style.overflow = '';
      toggle.setAttribute('aria-expanded', 'false');
      doc.removeEventListener('keydown', onKey);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function finish() { if (dirty && form) { form.submit(); return; } visualClose(); } // apply pending filters on close
    // Suppress each checkbox's inline auto-submit on mobile so selections batch; capture phase beats the inline handler.
    if (form) form.addEventListener('change', function (e) {
      var t = e.target; if (!t || window.innerWidth > 749) return;
      if (t.type === 'checkbox') {
        e.stopImmediatePropagation();
        dirty = true;
        var l = t.closest('.col-facet-opt'); if (l) l.classList.toggle('is-active', t.checked);
      } else if (t.closest && t.closest('.col-facet-price')) {
        dirty = true; // price min/max — apply on close too
      }
    }, true);
    toggle.addEventListener('click', open);
    $$('[data-filter-close]').forEach(function (b) { b.addEventListener('click', finish); });
  })();

  /* ---- phone fields: accept only phone chars (digits + spaces, plus + ( ) -), site-wide ---- */
  $$('[data-phone-input]').forEach(function (el) {
    el.addEventListener('input', function () {
      var cleaned = el.value.replace(/[^0-9+()\-\s]/g, '');
      if (cleaned !== el.value) el.value = cleaned;
    });
  });
})();

/* ---- WhatsApp click tracking → GTM dataLayer (so wa.me conversions are measurable) ---- */
(function () {
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href*="wa.me"], a[href*="api.whatsapp"], a[href^="whatsapp:"]') : null;
    if (!a) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'whatsapp_click', link_url: a.href, link_text: (a.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80), page_path: location.pathname });
  }, true);
})();

/* ---- same-day badges: shown only while today's cut-off is still open, in STORE time (Asia/Dubai).
   Product-card HTML is cached by Shopify, so the reveal has to happen client-side — otherwise an
   evening visitor could be served a morning page still promising same-day. ---- */
(function () {
  var cutoff = (window.theme || {}).cutoffHour;
  if (cutoff == null || isNaN(parseInt(cutoff, 10))) return;
  cutoff = parseInt(cutoff, 10);
  function dubaiNow() { return new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Dubai' })); }
  function update() {
    var els = document.querySelectorAll('[data-sameday-badge]');
    if (!els.length) return;
    var n = dubaiNow();
    var open = (n.getHours() * 60 + n.getMinutes()) < cutoff * 60;
    Array.prototype.forEach.call(els, function (el) { el.hidden = !open; });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update); else update();
  setInterval(update, 60000);
})();
